import React from 'react';

import { BOOK_LIVE_DEMO_URL } from 'app/constants';
import useIsMobile from 'hooks/use-is-mobile';
import ContentCard from 'pages/Landings/components/ContentCard';

import demo from './assets/demo-image.png?file';
import useStyles from './styles';

import ActionButton from '../ActionButton';

interface Props {
    className?: string;
}

const Demo: React.FC<Props> = ({ className }) => {
    const { classes } = useStyles();
    const isMobile = useIsMobile();

    return (
        <ContentCard
            align="center"
            picture={<img src={demo} className={classes.image} />}
            title={'Book a live demo'}
            description={
                <>
                    {'Pick a slot in a calendar to have a video call, most likely it will be with Andrey Lukashenkov'}
                    &nbsp;
                    <a
                        href="https://linkedin.com/in/alukashenkov/"
                        target="_blank"
                        rel="noopener noreferrer"
                        className={classes.link}
                    >
                        {'🔗 Linkedin'}
                    </a>
                </>
            }
            actions={
                <ActionButton color="dark" href={BOOK_LIVE_DEMO_URL} fullWidth={isMobile}>
                    {'Book live demo'}
                </ActionButton>
            }
            className={className}
        />
    );
};

export default Demo;
